var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMemo } from 'react';
import dayjs from 'dayjs';
import { EarlyAccessPhase } from '../types';
export var useEarlyAccessPhase = function (openCampaigns, upcomingCampaigns) {
    if (openCampaigns === void 0) { openCampaigns = []; }
    if (upcomingCampaigns === void 0) { upcomingCampaigns = []; }
    return useMemo(function () {
        var currentDate = dayjs();
        if (!Array.isArray(openCampaigns) || !Array.isArray(upcomingCampaigns)) {
            return EarlyAccessPhase.Invalid;
        }
        if (openCampaigns.length === 0 && upcomingCampaigns.length === 0) {
            return EarlyAccessPhase.Invalid;
        }
        if (openCampaigns.length !== 0) {
            return EarlyAccessPhase.EarlyAccess;
        }
        var startsAt = __spreadArray(__spreadArray([], openCampaigns, true), upcomingCampaigns, true)[0].startsAt;
        var startDate = dayjs(startsAt);
        if (!startDate.isValid()) {
            return EarlyAccessPhase.Invalid;
        }
        var difference = startDate.diff(currentDate, 'hour');
        if (difference > 11) {
            return EarlyAccessPhase.BuildUp;
        }
        return EarlyAccessPhase.PreEarlyAccess;
    }, [openCampaigns, upcomingCampaigns]);
};
